export default "__VITE_ASSET__d28a7bd1__"